<script>
  import { tabNext } from 'public/directives/next'
  import { Select } from 'element-ui'
  import { union, difference } from 'lodash'
  import { Clickoutside } from './Clickoutside'
  import historyMixins from './mixins/history'
  import popoverMixins from './mixins/popover'

  const MIXINS = {
    data () {
      return {
        newInputHovering: false // 鼠标悬浮状态，内部变量inputHovering只有输入文本框悬浮时才为true
      }
    }
  }

  // 混入历史功能的mixins。仅在mounted挂载时赋值，在数据变化（watch->value）时存储
  Select.mixins = [...Select.mixins, MIXINS, historyMixins, popoverMixins]

  const KSelect = {
    ...Select,
    props: {
      ...Select.props,
      showClearAll: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...Select.computed,
      iconClass () {
        const t = this
        const hasValue =
          t.multiple && Array.isArray(t.value) && t.showClearAll
            ? t.value.length > 0
            : t.value !== null && t.value !== undefined && t.value !== ''
        const clearable = t.multiple ? t.showClearAll : t.clearable
        const criteria = clearable && !t.selectDisabled && t.newInputHovering && hasValue
        return criteria ? 'circle-close is-show-close' : t.remote && t.filterable ? '' : 'arrow-up'
      }
    },
    directives: { Clickoutside }
  }

  export default {
    name: 'kye-select',
    props: {
      user: {
        type: Boolean,
        default: false
      },
      disableDelete: {
        type: Boolean,
        default: false
      },
      showSwitch: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        inputEl: null,
        isAllSelected: false,
        indeterminate: false
      }
    },
    mounted () {
      this.resetEnter()
      this.resetDeleteSelected()
      this.setDelete()
      this.resetNavigateOptions()
      if (this.user) {
        this.resetHandleQueryChange()
      }

      this.$el.addEventListener('mouseenter', this.mouseenter)
      this.$el.addEventListener('mouseleave', this.mouseleave)

      this.watchSelectVisibleChange()

      if (this.showSwitch) {
        this.watchOpitonsCountChange()
      }
    },
    beforeDestroy () {
      this.inputEl && this.inputEl.removeEventListener('keydown', this.keyDown)
      this.$el.removeEventListener('mouseenter', this.mouseenter)
      this.$el.removeEventListener('mouseleave', this.mouseleave)
      this._unWatchSelectVisibleChange && this._unWatchSelectVisibleChange()
      this._unWatchOptionsCountChange && this._unWatchOptionsCountChange()
    },
    render (h) {
      const data = this.$vnode.data
      const on = { ...data.on, ...this.$listeners }
      data.on = on
      data.ref = 'elSelect'

      let props = Object.assign(data.props || {}, this.$attrs)

      let value = props.value || this.$attrs.value || ''

      let multiple = !(props.multiple === undefined || props.multiple === false)

      if (typeof value === 'number') {
        value = String(value)
        props.value = value
        if (data.model) {
          data.model.value = value
        }
      }

      if (!props.hasOwnProperty('filterable')) {
        props.defaultFirstOption = true
        props.clearable = props.clearable === undefined ? true : props.clearable
        props.filterable = true
        // props.filterMethod = e => this.filterByIndex(e, !data.model && on.input)
        // if (!props.options) {
        //   let arr = this.$vnode.componentOptions.children
        //   if (arr) {
        //     props.options = arr.reduce((s, v) => {
        //       if (v.componentOptions && v.componentOptions.propsData) {
        //         s.push(v.componentOptions.propsData.value)
        //       }
        //       return s
        //     }, [])
        //   }
        // }
      }

      if (this.$attrs.remote && data.attrs) {
        data.attrs.name = 'remote'
      }
      data.props = props

      // 2022-12-19 全选功能
      if (this.showSwitch && multiple) {
        this.setAllSelect()
        const renderAllSelectOption = h => {
          const slots = this.$slots.default || []
          const prefix = this.$slots.prefix || []
            return [...prefix, h('el-checkbox', {
                    props: {
                      value: this.isAllSelected,
                      indeterminate: this.indeterminate
                    },
                    class: 'kye-select__switch',
                    on: {
                      change: this.clickAllSelect
                    }
            }, '全选'), ...slots]
        }
        return h(KSelect, data, renderAllSelectOption(h))
      }

      return h(KSelect, data, this.$slots.default)
    },
    methods: {
      resetEnter () {
        let c = this.$children[0]
        if (c) {
          c.selectOption = e => {
            if (!c.visible) {
              c.toggleMenu()
            } else {
              // 当前激活的选项
              if (c.options[c.hoverIndex]) {
                c.handleOptionSelect(c.options[c.hoverIndex])
                // 历史选择过的选项
              } else if (c.hoverOption !== -1) {
                let index = c.options.findIndex(t => c.hoverOption.currentValue === t.currentValue)
                if (index > -1) {
                  c.handleOptionSelect(c.options[index])
                }
              }
              // 没有匹配的选项时，回车清空绑定的值
              if (c.emptyText !== null) {
                c.$emit('input', c.multiple ? (Array.isArray(c.value) ? c.value : []) : '')
              }
              // 回车键next
              tabNext(e.target)
              c.visible = false
            }
          }
        }
      },
      resetNavigateOptions () {
        let c = this.$children[0]
        if (c) {
          let n = c.navigateOptions
          c.navigateOptions = e => {
            if (c.hoverIndex === -1 && c.hoverOption !== -1) {
              c.hoverIndex = c.options.findIndex(t => c.hoverOption.currentValue === t.currentValue)
            }
            n(e)
          }
        }
      },
      // 全选按钮状态
      setAllSelect () {
        this.$nextTick(_ => {
          let c = this.$children[0]
          if (c && Array.isArray(c.value)) {
            const arr = this.getSelectOptions(c)
            // 远程下拉初始化无数据
            if (arr.length === 0) {
              return
            }

            // value是否在下拉选项当中
            let actVal = c.value.filter(v => arr.includes(v))
            // 判断是否全选
            this.isAllSelected = actVal.length === arr.length
            this.indeterminate = !this.isAllSelected && actVal.length > 0
          }
        })
      },
      // 全选事件
      clickAllSelect () {
        this.isAllSelected = !this.isAllSelected
        const c = this.$children[0]
        const currentVal = c.value
        const selectVal = this.getSelectOptions(c)
        const value = this.isAllSelected ? union(currentVal, selectVal) : difference(currentVal, selectVal)
        c.$emit('checkboxChange', value)
        c.$emit('input', value)
        c.$emit('change', value)
      },
      // 2022-12-19 搜索结果全选 visible 在el-select内部是控制下拉显示/隐藏的
      getSelectOptions (vm) {
        return vm.options.filter(item => item.visible && !item.disabled).map(item => item.value)
      },
      // 全选悬浮
      allSelectOptionHover () {
        let c = this.$refs.elSelect
        c.hoverIndex = -1
        c.hoverOption = -1
      },
      setDelete () {
        this.inputEl = this.$el.querySelector('input')
        this.inputEl && this.inputEl.addEventListener('keydown', this.keyDown)
      },
      keyDown (e) {
        if (e.keyCode === 8 || e.keyCode === 46) {
          let c = this.$children[0]
          if (c) {
            if (this.disableDelete) {
              return
            }
            if (c.multiple && c.query) {
              return
            }
            let v = this.$attrs.value
            let arr = Array.isArray(v) && v.length > 1 ? v.slice(0, -1) : []
            c.$emit('input', c.multiple ? arr : '')
            c.$emit('change', c.multiple ? arr : '')
            c.$emit('clear')
          }
        }
      },
      resetHandleQueryChange() {
        let c = this.$children[0]
        if (c) {
          c.handleQueryChange = val => {
            if (c.previousQuery === val || c.isOnComposition) return
            if (
              c.previousQuery === null &&
              (typeof c.filterMethod === 'function' || typeof c.remoteMethod === 'function')
            ) {
              c.previousQuery = val
              return
            }
            c.previousQuery = val
            c.$nextTick(() => {
              if (c.visible) c.broadcast('ElSelectDropdown', 'updatePopper')
            })
            c.hoverIndex = -1
            if (c.multiple && c.filterable) {
              const length = c.$refs.input.value.length * 15 + 20
              c.inputLength = c.collapseTags ? Math.min(50, length) : length
              c.managePlaceholder()
              c.resetInputHeight()
            }
            if (c.optionsCount && this.user && val && /\s+/.test(val)) {
              let value = val.replace(/\s+/, ' ')
              let arr = value.split(' ')
              if (arr[0] && arr[0].length > 1 && arr[1]) {
                c.filteredOptionsCount = c.optionsCount
                c.broadcast('ElOption', 'queryChange', arr[1])
                c.broadcast('ElOptionGroup', 'queryChange')
              } else if (arr[0] && arr[0].length > 1 && !arr[1]) {
                c.filteredOptionsCount = c.optionsCount
                c.broadcast('ElOption', 'queryChange', '')
                c.broadcast('ElOptionGroup', 'queryChange')
              }
            } else if (c.remote && typeof c.remoteMethod === 'function') {
              c.hoverIndex = -1
              c.remoteMethod(val)
            } else if (typeof c.filterMethod === 'function') {
              c.filterMethod(val)
              c.broadcast('ElOptionGroup', 'queryChange')
            } else {
              c.filteredOptionsCount = c.optionsCount
              c.broadcast('ElOption', 'queryChange', val)
              c.broadcast('ElOptionGroup', 'queryChange')
            }
            if (c.defaultFirstOption && (c.filterable || c.remote) && c.filteredOptionsCount) {
              c.checkDefaultFirstOption()
            }
          }
        }
      },
      focus () {
        this.$children[0] && this.$children[0].focus()
      },
      // 输入子项序号自动匹配选择
      filterByIndex (val, input) {
        const index = +val - 1
        const context = this.$vnode
        const { options } = context.data.props
        if (options && !isNaN(index) && options[index]) {
          let multiple = context.data.props.multiple
          let value = multiple === undefined || multiple === false ? options[index] : [options[index]]
          context.data.props.value = value
          if (context.data.model) {
            context.data.model.value = value
            context.data.model.callback(value)
          } else if (input) {
            input(value)
          }
        }
      },
      resetDeleteSelected () {
        let c = this.$children[0]
        if (c) {
          c.deleteSelected = e => {
            e.stopPropagation()
            // 多选支持全清除
            const canClearAll = c.multiple && Array.isArray(c.value) && c.showClearAll
            const val = canClearAll ? [] : ''
            c.$emit('input', val)
            c.$emit('change', val)
            c.$emit('clear')
            c.visible = false
          }
        }
      },
      mouseenter () {
        let c = this.$children[0]
        if (c) {
          c.newInputHovering = true
        }
      },
      mouseleave () {
        let c = this.$children[0]
        if (c) {
          c.newInputHovering = false
        }
      },
      // 修复bug，多选模式下，靠左点击，需要两次才唤起面板
      watchSelectVisibleChange () {
        try {
          const c = this.$children[0]
          this._unWatchSelectVisibleChange = this.$watch(
            () => c.visible,
            val => {
              if (!val) {
                c.menuVisibleOnFocus = false
              }
            }
          )
        } catch (error) {
          console.error('Error in watchSelectVisibleChange:', error)
        }
      },
      watchOpitonsCountChange () {
        try {
          const c = this.$children[0]
          this._unWatchOptionsCountChange = this.$watch(
            () => c.filteredOptionsCount,
            val => {
              this.setAllSelect()
            }
          )
        } catch (error) {
          console.error('Error in watchOpitonsCountChange:', error)
        }
      }
    }
  }
</script>

<style lang="scss">
.el-select {
  .el-select__tags {
    display: flex;
    align-items: center;
    height: 28px;
    flex-wrap: nowrap;
    overflow: hidden;
    max-width: none;
    // width: calc(100% - 30px);
    > span {
      display: flex;
      align-items: center;
      overflow: hidden;
      > span:first-child.el-tag--info {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        display: flex;
        align-items: center;
        max-width: none !important;
        margin: 2px !important;
        .el-select__tags-text {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          min-width: 12px;
        }
      }
      > span:last-child.el-tag--info {
        overflow: initial !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-select/index.vue